/**
 * Sends Live Activity commands to the iOS native layer via a direct
 * WKScriptMessageHandler named "liveActivity".
 *
 * Using webkit.messageHandlers directly avoids the Capacitor plugin-proxy
 * lookup that requires @capacitor/core's registerPlugin() to be called first.
 *
 * All functions are safe no-ops on non-iOS or web platforms.
 */

const getLiveActivityHandler = () =>
  typeof window !== 'undefined' ? window?.webkit?.messageHandlers?.liveActivity : undefined;

const call = (action, params) => {
  const handler = getLiveActivityHandler();
  if (!handler) return;
  console.log('[LiveActivity] messageHandler.' + action, params);
  try {
    handler.postMessage({ action, params });
  } catch (e) {
    console.error('[LiveActivity] postMessage error', e);
  }
};

/**
 * Start a new charging Live Activity.
 * @param {{ stationNumber: string, periodKwh: number, wattsPerKm: number,
 *           chargedKwh: number, powerKw: number, soc: number|null,
 *           leftSeconds: number, isOnline: boolean }} params
 */
export const startChargingLiveActivity = params => call('start', params);

/**
 * Push updated state to the running Live Activity.
 * @param {{ chargedKwh: number, powerKw: number, soc: number|null,
 *           leftSeconds: number, isOnline: boolean }} params
 */
export const updateChargingLiveActivity = params => call('update', params);

/**
 * End the Live Activity and show final state on lock screen for 1 h.
 * @param {{ chargedKwh: number, powerKw: number, soc: number|null }} params
 */
export const endChargingLiveActivity = params => call('end', params);
